import PropTypes from 'prop-types';

// material-ui
import { Box, Typography, Tooltip } from '@mui/material';

// third-party
// import { format } from 'date-fns';
import { FormattedMessage, useIntl } from 'react-intl';

// ==============================|| RENDER DURATION ||============================== //

const RenderAlarmSettings = ({ value }) => {
    const intl = useIntl();

    if (!value) return <Box />;

    const { scheduleType } = value;

    return (
        <Tooltip
            title={
                <Typography variant="inherit" color="inherit">
                    <>
                        {scheduleType && (
                            <>
                                {`${intl.formatMessage({ id: 'entity-admin-alarm-scheduletype' })}: ${intl.formatMessage({
                                    id: `ui-comp-form-alarmscheduletype-${scheduleType?.toLowerCase() || 'none'}`
                                })}`}
                                <br />
                            </>
                        )}
                    </>
                </Typography>
            }
        >
            <Typography color="inherit" variant="inherit">
                <FormattedMessage id={`ui-comp-form-alarmscheduletype-${scheduleType?.toLowerCase() || 'none'}`} />
            </Typography>
        </Tooltip>
    );
};

RenderAlarmSettings.propTypes = {
    value: PropTypes.object
};

export default RenderAlarmSettings;
